export var SortingEnum;
(function (SortingEnum) {
    SortingEnum["Alphabetic"] = "alphabetic";
    SortingEnum["Default"] = "default";
    SortingEnum["PriceFromLowToHigh"] = "priceFromLowToHigh";
    SortingEnum["PriceFromHighToLow"] = "priceFromHighToLow";
})(SortingEnum || (SortingEnum = {}));
